import { Button, visuallyHiddenStyles } from "@newsela/angelou";

import MinusIcon from "@/icons/MinusIcon";
import PlusIcon from "@/icons/PlusIcon";
import InlineImage from "../InlineImage";
import { iconCss, imgButtonCss } from "../ProseMirrorImageBlock.style";

interface ZoomableImageProps {
  currentImage: {
    url: string;
    alt_text?: string;
  };
  isImageExpanded?: boolean;
  toggleZoom: () => void;
}

const ZoomableImage = ({
  currentImage,
  isImageExpanded,
  toggleZoom,
}: ZoomableImageProps) => {
  const screenReaderText = isImageExpanded ? "Zoom out image" : "Zoom in image";
  const Icon = isImageExpanded ? MinusIcon : PlusIcon;

  return (
    <Button
      onClick={toggleZoom}
      flavor={Button.flavors.incognito}
      ariaProps={{ "aria-expanded": isImageExpanded }}
      __cssFor={{ root: imgButtonCss }}
    >
      <InlineImage currentImage={currentImage} isDecorative />
      <div title={screenReaderText} css={iconCss}>
        <Icon />
      </div>
      <span css={visuallyHiddenStyles}>{screenReaderText}</span>
    </Button>
  );
};

export default ZoomableImage;
